/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'phone': {
    width: 13,
    height: 13,
    viewBox: '0 0 13 13',
    data: '<path pid="0" fill-rule="evenodd" d="M1.78.03C.809.407.198 1.792.054 2.745c-.45 3.092 1.996 5.771 4.243 7.533 1.996 1.564 5.826 4.136 8.091 1.654.288-.305.63-.755.611-1.204-.054-.755-.755-1.295-1.294-1.708-.414-.306-1.277-1.151-1.816-1.133-.486.018-.791.521-1.097.827l-.54.54c-.09.09-1.24-.666-1.366-.756a9.175 9.175 0 01-1.312-1.025 8.477 8.477 0 01-1.061-1.222c-.09-.126-.827-1.223-.755-1.313 0 0 .629-.683.809-.953.377-.575.665-1.025.234-1.708-.162-.251-.36-.45-.576-.665C3.848 1.252 3.47.875 3.04.569c-.234-.18-.63-.503-.99-.557A.452.452 0 001.78.03z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/dist/icons/phone.js